import KeepNType from 'owa-service/lib/contract/KeepNType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import getFolderFromId from '../utils/folderTypeConversionUtil';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { BulkActionCustomDataBase, lazyOnBulkActionSubmitted } from 'owa-bulk-action-store';
import applyBulkItemActionService from '../services/applyBulkItemActionService';
import executeInboxRulesService from '../services/executeInboxRulesService';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import { orchestrator } from 'satcheljs';
import InboxRule from 'owa-service/lib/contract/InboxRule';

const MAX_RULE_NAME_LENGTH = 180;

export interface RuleBulkActionCustomData extends BulkActionCustomDataBase {
    ruleId: string;
    ruleName: string;
}

export default orchestrator(runRuleNow, actionMessage => {
    let mailboxesToSweep: EmailAddressWrapper[] = [];
    let destinationFolderId: string;
    let bulkActionCustomData: RuleBulkActionCustomData;
    let useApplyBulkAction = true;
    const inboxRule: InboxRule = actionMessage.inboxRule;
    const sourceFolderId = actionMessage.sourceFolderId
        ? actionMessage.sourceFolderId
        : folderNameToId('inbox');

    if (inboxRule.From) {
        for (let identity of inboxRule.From) {
            let mailbox: EmailAddressWrapper = {
                Name: identity.DisplayName,
                EmailAddress: identity.SmtpAddress,
                RoutingType: identity.RoutingType,
            };
            mailboxesToSweep.push(mailbox);
        }
    } else {
        useApplyBulkAction = false;
    }

    if (useApplyBulkAction) {
        if (inboxRule.MoveToFolder) {
            let destinationFolder = getFolderFromId(inboxRule.MoveToFolder.RawIdentity);
            if (!destinationFolder) {
                throw new Error('Destination folder does not exist in store');
            } else {
                destinationFolderId = destinationFolder.folderId;
            }
        } else if (inboxRule.DeleteMessage) {
            destinationFolderId = folderNameToId('deleteditems');
        } else {
            useApplyBulkAction = false;
        }
    }

    // Need to truncate the ruleName field to avoid passing the JSON 256 byte limit
    const concatRuleName =
        inboxRule.Name.length > MAX_RULE_NAME_LENGTH
            ? inboxRule.Name.slice(0, MAX_RULE_NAME_LENGTH) + '...'
            : inboxRule.Name;

    bulkActionCustomData = {
        Scenario: 'RunRuleNow',
        ruleName: concatRuleName,
        ruleId: inboxRule.Identity.RawIdentity.split('\\').pop(),
    };

    if (useApplyBulkAction) {
        lazyOnBulkActionSubmitted.importAndExecute(sourceFolderId, 'Sweep', bulkActionCustomData);

        applyBulkItemActionService(
            BulkTriageActionType.Move,
            mailboxesToSweep,
            sourceFolderId,
            KeepNType.Items,
            0,
            destinationFolderId,
            bulkActionCustomData
        );
    } else {
        lazyOnBulkActionSubmitted.importAndExecute(
            sourceFolderId,
            'RunRuleNow',
            bulkActionCustomData
        );

        executeInboxRulesService(
            inboxRule.Identity.RawIdentity,
            sourceFolderId,
            bulkActionCustomData
        );
    }
});
